<template>
  <div id="app">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
      {{ $t("MyRedemption.title") }}
    </div>
    <div class="person">
      <img class="mine-img" :src="mineImage" alt="" />
      {{ userInfo?.phoneNumber || userInfo?.email }}
    </div>
    <div class="title">{{ $t("MyRedemption.title") }}</div>
    <div style="max-height:440px;overflow:hidden">
      <div class="list" v-for="item in orderList" :key="item.orderID">
        <div style="display:flex">
          <div class="left">
          <div class="name">
            <span v-if="item.productName=='音视频通话' || item.productName=='音/视频通话'">{{ $t("AudioVideoPage.title")}} </span>
            <span v-if="item.productName=='离线翻译'">{{ $t("RedemptionCodePage.OfflineTranslation")}} </span>
            <span v-if="item.productName==='基础服务（一个月）'">{{$t("basePage.title")}} ({{$t("basePage.month1")}})</span>
            <span v-if="item.productName==='基础服务（半年）'">{{$t("basePage.title")}} ({{$t("basePage.month2")}})</span>
            <span v-if="item.productName==='基础服务（年）'">{{$t("basePage.title")}} ({{$t("basePage.month3")}})</span>
          </div>
        </div>
        <div :class="{ right: lang == 'cn', right1: lang !== 'cn' }">
          <el-button class="view" @click="handleView(item)">{{
            $t("RedemptionList.view")
          }}</el-button>
        </div>
        </div>
        
        <div class="time">
            {{ $t("RedemptionList.time") }}{{ item.purchaseTime }}
          </div>
      </div>
    </div>

    <div style="padding-bottom: 24px;margin-left:-8px">
      <el-pagination
        @size-change="handleSizeChange"
        :page-size="5"
        @current-change="handleCurrentChange"
        v-if="orderList.length != 0"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
      
      <script>
import { getUser, getTransactionOrders } from "@/api/login/user";
export default {
  name: "RedemptionList",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      orderList: [],
      currentPage: 1,
      total: 0,
      userInfo: {
        username: "",
      },
      closeImage: require("@/assets/close.png"),
      mineImage: require("@/assets/mine.png"),
      list: [],
      list1: [
        {
          name: "离线翻译",
          id: 1,
          time: "2025-02-02 13:32",
        },
        {
          name: "音/视频通话",
          id: 2,
          time: "2025-02-02 13:32",
        },
        {
          name: "基础服务",
          id: 3,
          time: "2025-02-02 13:32",
        },
      ],
      list2: [
        {
          name: "Offline translation",
          id: 1,
          time: "2025-02-02 13:32",
        },
        {
          name: "Audio/Video Call",
          id: 2,
          time: "2025-02-02 13:32",
        },
        {
          name: "Offline translation",
          id: 3,
          time: "2025-02-02 13:32",
        },
      ],
      lang: "cn",
    };
  },
  watch: {
    lang(val) {
      this.lang = val;
    },
  },
  async mounted() {
    this.lang = localStorage.getItem("lang") || "cn";
    this.getUserNet();
    const params = {
      productType: "",
      orderID: "",
      page: 1,
      limit: 5,
      expandOrderType:"exchange"
    };
    getTransactionOrders(params).then((res) => {
      if (res?.data) {
        this.orderList = res.data;
        this.total = res.count;
      }
    });
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      const params = {
        productType: "",
        orderID: "",
        page: val,
        limit: 5,
        expandOrderType:"exchange"
      };
      getTransactionOrders(params).then((res) => {
        if (res?.data) {
          this.orderList = res.data;
          this.total = res.count;
        }
      });
    },
    getUserNet() {
      getUser().then((res) => {
        this.userInfo = res?.data;
      });
    },
    goBack() {
      this.$router.push({
        path: "/RedemptionPage",
      });
    },
    handleView(val) {
      this.$router.push({
        path: "/MyRedemption",
        query: {
          name: val.name,
          id: val.id,
        },
      });
      localStorage.setItem("MyRedemption", JSON.stringify(val));
    },
  },
};
</script>
      
      <style scoped>
#app {
  height: 100vh;
  text-align: left;
  background: #f5f5f5;
  overflow: hidden;
  padding:0px 16px
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}
.person {
  width: 100%;
  height: 76px;
  border-radius: 16px;
  background: #ffffff;
  margin-top: 12px;
}
.mine-img {
  width: 44px;
  height: 44px;
  padding: 16px;
  vertical-align: middle;
}
.title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: normal;
  color: #3d3d3d;
  margin-top: 16px;
}
.list {
  width: 100%;
  min-height: 79px;
  border-radius: 16px;
  background: #ffffff;
  /* margin-block: 16px; */
  margin:8px 0px;
}
.left {
  flex:1;
  float: left;
  padding: 16px 16px 0px 16px;
}
.right {
  float: right;
  padding: 16px 16px 0px 16px;
  margin: 8px 0px 0px 42px;
}
.name {
  min-height: 20px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  /* padding-bottom: 8px; */
}
.time {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  padding-left:16px;
}
.view {
  height: 32px;
  line-height: 7px;
  border-radius: 8px;
  /* 2-辅色 */
  background: #201f34;
  color: #fff;
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
}
.view >>> .el-button:active .el-button:focus,
.el-button:hover {
  background: #201f34;
  color: #fff;
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
}
.right1 {
  float: right;
  padding: 13px 5px 0px 0px;
  margin-top: 8px;
}
</style>
      